export const TRANSLATION_SCOPE = 'assetModule';
export const TRANSLATION_MEDIA_CENTER_SCOPE = [TRANSLATION_SCOPE, 'mediaCenter'];
